import profile from './account/profile';
import business from './account/business';
import configuration from './account/configuration';
import notifications from './account/notifications';

export default {
  en: {
    title: 'Account',
    tooltip: 'Modify your account, settings and data',
    profile: profile.en,
    business: business.en,
    configuration: configuration.en,
    notifications: notifications.en,
    feedbackTooltip: 'Suggest features, vote and comment',
  },
  es: {
    title: 'Cuenta',
    tooltip: 'Modifique su cuenta, configuración y datos',
    profile: profile.es,
    business: business.es,
    configuration: configuration.es,
    notifications: notifications.es,
    feedbackTooltip: 'Sugiere una función, vota y comenta',
  },
  fr: {
    title: 'Compte',
    tooltip: 'Modifiez votre compte, vos paramètres et vos données',
    profile: profile.fr,
    business: business.fr,
    configuration: configuration.fr,
    notifications: notifications.fr,
    feedbackTooltip: 'Suggérez une fonctionnalité, votez et commentez',
}

};
